<template lang="html">
  <modal name="add-user-modal" :adaptive="true" height="auto" width="416" :maxWidth="416" class="add-user-modal" @before-open="beforeOpen">
    <div class="modal-container">
      <div class="modal-header bold black">
        Add User
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div>Adding a new user will automatically grant them Basic level permissions.</div>
        <div class="gap-3x" />
        <SymbiumFormGroup
          label="Email"
          v-bind:value.sync="email"
          @update:value="onEmailChange"
          :error="errors.email"
          inputSize="input-full-width"
          klass="max-size"
        />
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer flex-box">
        <div class="cancel-section">
          <SymbiumButton
            kclass="btn-base dialog-btn"
            :isSmall="true"
            text="Cancel"
            :onClick="() => this.$modal.hide('add-user-modal')"
          />
        </div>

        <SymbiumButton
          kclass="btn-base"
          :isSmall="true"
          text="Add User"
          :onClick="addUser"
          :loading="loading"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'
import EventBus from 'src/components/EventBus.js'
import _ from 'lodash';

export default {
  components: { SymbiumButton, SymbiumFormGroup },
  props: ['productName'],
  data() {
    return {
      email: null,
      role: null,
      errors: {},
      loading: false,
      availableRoles: {},
      needToAddMoreUser: false
    }
  },
  methods: {
    onEmailChange(value) {
      this.email = value;
      this.errors.email = null;
    },
    addUser() {
      this.loading = true;
      var data = { email: this.email, productName: this.productName }
      this.$organization.createUser(data, this.afterAddUser, this.afterFailedAddUser)
    },
    afterAddUser() {
      EventBus.$emit('buildplus-user-added', this.email)
    },
    afterFailedAddUser(data) {
      this.errors = data.errors || { 'email': 'Error while adding user' };
      this.loading = false;
    },
    beforeOpen(event) {
      this.availableRoles = event.params.availableRoles;
      this.email = null;
      this.errors = {};
      this.loading = false;
    }
  },
  computed: {
    roles() {
      return _.keys(this.availableRoles);
    }
  },
  watch: {
    role() {
      this.errors.role = null
    }
  }
}
</script>

<style lang="scss">

.add-user-modal {
  .oval-button {
    float: none;
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.07px;
    padding: 8px 16px;
  }

  .cancel-section {
    flex-grow: 1;
    text-align: left;
  }

  .submit-add-user {
    min-width: 96px;
  }
}
</style>
